var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Search } from '@mui/icons-material';
import { Chip, useMediaQuery } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { FilterIcon, PlusHeaderIcon } from '../../../assets/customIcons';
import { getUpdateKey } from '../../../builderPackage/common/commonFunctions';
import { DynamicFormBuilderContainer } from '../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container';
import { FormItemTypes } from '../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity';
import { LOCAL_STORAGE_KEYS } from '../../../constants';
import { showSurface } from '../../../redux/awaitedSurfacesSlice';
import { setReducerState } from '../../../redux/crudSlice';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { getLocalStorageItem, removeLocalStorageItem } from '../../../utils/storageHelper';
import FailedTab from '../components/failedTab';
import NewFilterDrawer from '../components/newFilterDrawer';
import PassedTab from '../components/passedTab';
import { PDIStatusPagingCountAPI } from '../services/apiCalls';
import { PDICheckKeys } from '../services/entity';
var NewPDICheckPaging = function () {
    var _getLocalStorageItem, _getLocalStorageItem2, _getLocalStorageItem3;
    var crud = useAppSelector(function (state) { return state.crud; });
    var isMobile = useMediaQuery(function (theme) { return theme.breakpoints.down("sm"); });
    var IdentityId = (_getLocalStorageItem = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)) === null || _getLocalStorageItem === void 0 || (_getLocalStorageItem = _getLocalStorageItem.data) === null || _getLocalStorageItem === void 0 ? void 0 : _getLocalStorageItem.IdentityId;
    var listVariants = [{
            Name: "My PDI check",
            id: IdentityId
        }, {
            Name: 'All PDI check',
            id: 'all'
        }];
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var userOrganizationID = (_getLocalStorageItem2 = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)) === null || _getLocalStorageItem2 === void 0 || (_getLocalStorageItem2 = _getLocalStorageItem2.data) === null || _getLocalStorageItem2 === void 0 || (_getLocalStorageItem2 = _getLocalStorageItem2.Branches[0]) === null || _getLocalStorageItem2 === void 0 ? void 0 : _getLocalStorageItem2.OrganizationId;
    var parentOrganizationId = (_getLocalStorageItem3 = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)) === null || _getLocalStorageItem3 === void 0 || (_getLocalStorageItem3 = _getLocalStorageItem3.data) === null || _getLocalStorageItem3 === void 0 || (_getLocalStorageItem3 = _getLocalStorageItem3.Branches[0]) === null || _getLocalStorageItem3 === void 0 ? void 0 : _getLocalStorageItem3.ParentOrganizationId;
    var FILTER_APPLY = getLocalStorageItem(LOCAL_STORAGE_KEYS.FILTER_APPLY);
    var PDIPassTAb = [{
            type: FormItemTypes.Custom,
            name: 'pass',
            element: PassedTab,
            columnSize: 12
        }];
    var PDIFailTAb = [{
            type: FormItemTypes.Custom,
            name: 'fail',
            element: FailedTab,
            columnSize: 12
        }];
    var formData = [{
            type: FormItemTypes.ContainerItem,
            name: 'header',
            columnSize: 12,
            spacing: 0,
            px: 3,
            py: 2,
            elements: [{
                    type: FormItemTypes.SingleSelect,
                    name: 'IdentityId',
                    value: 'all',
                    options: listVariants,
                    valueExpr: 'id',
                    displayExpr: 'Name',
                    size: 'medium',
                    columnSize: 0,
                    disableUnderline: true,
                    variant: 'standard',
                    SelectDisplayProps: {
                        style: {
                            fontSize: 'inherit',
                            paddingTop: '0px',
                            paddingBottom: '0px'
                        }
                    },
                    sx: {
                        fontWeight: 'strong',
                        fontSize: 'xxl'
                    }
                }]
        }, {
            type: FormItemTypes.ContainerItem,
            name: 'actions',
            spacing: 0,
            columnGap: 2,
            padding: '16px 24px',
            borderTop: '1px solid ',
            borderBottom: '1px solid ',
            borderColor: 'secondary.200',
            bgcolor: 'secondary.100',
            columnSize: 12,
            justifyContent: 'space-between',
            alignItems: 'center',
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: 'searchBar',
                    alignItems: 'center',
                    spacing: 0,
                    columnGap: 0.5,
                    borderRadius: 2,
                    px: 1.25,
                    py: 0.5,
                    border: '1px solid',
                    borderColor: 'secondary.300',
                    bgcolor: 'white',
                    width: 'auto',
                    minWidth: {
                        xs: 0,
                        sm: 320
                    },
                    maxWidth: {
                        xs: 'none',
                        sm: 400
                    },
                    xs: true,
                    sm: 0,
                    elements: [{
                            type: FormItemTypes.IconButton,
                            name: 'searchButton',
                            columnSize: 0,
                            color: 'secondary',
                            children: /*#__PURE__*/ React.createElement(Search, {
                                color: "secondary"
                            })
                        }, {
                            type: FormItemTypes.TextInput,
                            name: 'search',
                            columnSize: true,
                            variant: 'standard',
                            placeholder: 'Search by doc no. VIN no. engine no.',
                            InputProps: {
                                disableUnderline: true
                            },
                            valueSetter: function (state, currValue, field) {
                                var _a;
                                return (_a = {},
                                    _a[field.name] = currValue === null || currValue === void 0 ? void 0 : currValue.trim(),
                                    _a);
                            }
                        }]
                }, {
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    justifyContent: 'end',
                    columnSize: 0,
                    width: 'auto',
                    alignItems: 'center',
                    elements: [{
                            type: FormItemTypes.Button,
                            name: '',
                            children: "".concat(!isMobile ? "Filters" : ''),
                            columnSize: 0,
                            color: 'secondary',
                            variant: 'outlined',
                            size: isMobile ? 'icon' : 'small',
                            startIcon: /*#__PURE__*/ React.createElement(FilterIcon, null),
                            // disabled: true
                            setFormState: function (formValues) { return __awaiter(void 0, void 0, void 0, function () {
                                var res, _res$payload;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            removeLocalStorageItem(FILTER_APPLY);
                                            return [4 /*yield*/, dispatch(showSurface({
                                                    type: 'Drawer',
                                                    Component: NewFilterDrawer,
                                                    containerProps: {
                                                        PaperProps: {
                                                            sx: {
                                                                width: '400px',
                                                                paddingBottom: '64px'
                                                            }
                                                        },
                                                        anchor: 'right'
                                                    },
                                                    componentProps: {
                                                        data: formValues
                                                    }
                                                }))];
                                        case 1:
                                            res = _a.sent();
                                            if (res !== null && res !== void 0 && res.payload) {
                                                return [2 /*return*/, {
                                                        applyFilter: true,
                                                        filter: res === null || res === void 0 || (_res$payload = res.payload) === null || _res$payload === void 0 ? void 0 : _res$payload.data
                                                    }];
                                            }
                                            return [2 /*return*/, {}];
                                    }
                                });
                            }); }
                        }, {
                            type: FormItemTypes.Divider,
                            name: '',
                            variant: 'fullWidth',
                            orientation: 'vertical',
                            columnSize: 0,
                            hidden: isMobile
                        }, {
                            type: FormItemTypes.Button,
                            name: 'Newbtn',
                            children: 'New',
                            columnSize: 0,
                            color: 'primary',
                            variant: 'contained',
                            startIcon: /*#__PURE__*/ React.createElement(PlusHeaderIcon, null),
                            href: '/createpdicheck?mode=add',
                            hidden: isMobile
                            // onClick: () => {
                            //     navigate("/createpdicheck?mode=add");
                            // }
                        }]
                }]
        }, isMobile ? {
            type: FormItemTypes.Box,
            name: '',
            display: 'flex',
            columnSize: 12,
            position: 'fixed',
            bottom: 0,
            right: 0,
            bgcolor: 'white',
            p: 2,
            width: '100%',
            justifyContent: 'end',
            sx: {
                borderTop: '1px solid ',
                borderColor: '#DEE4EB',
                gap: '16px',
                zIndex: 5
            },
            elements: [{
                    type: FormItemTypes.Button,
                    name: 'Newbtn',
                    children: 'New',
                    columnSize: 12,
                    fullWidth: true,
                    color: 'primary',
                    variant: 'contained',
                    startIcon: /*#__PURE__*/ React.createElement(PlusHeaderIcon, null),
                    onClick: function () {
                        navigate("/createpdicheck?mode=add");
                    }
                }]
        } : null, {
            type: FormItemTypes.ContainerItem,
            name: '',
            label: '',
            value: null,
            columnSize: 12,
            spacing: 0,
            px: 3,
            sx: {
                marginBottom: '70px'
            },
            elements: [{
                    type: FormItemTypes.Tabs,
                    name: 'Tabs',
                    value: 'fail',
                    columnSize: 12,
                    valueExpr: 'id',
                    displayExpr: 'Name',
                    panelGridProps: {
                        spacing: 0
                    },
                    tabs: [],
                    setFieldProps: function (state) {
                        var _crud$PDICheckKeys$Pa, _crud$PDICheckKeys$Pa2, _crud$PDICheckKeys$Pa3, _crud$PDICheckKeys$Pa4, _crud$PDICheckKeys$Pa5, _crud$PDICheckKeys$Pa6;
                        console.log("filter--", state);
                        return {
                            tabs: [{
                                    id: 'fail',
                                    Name: 'Failed',
                                    elements: PDIFailTAb,
                                    tabProps: {
                                        iconPosition: 'end',
                                        icon: /*#__PURE__*/ React.createElement(Chip, {
                                            label: state !== null && state !== void 0 && state.applyFilter && (state === null || state === void 0 ? void 0 : state.Tabs) === "fail" && ((_crud$PDICheckKeys$Pa = crud[PDICheckKeys === null || PDICheckKeys === void 0 ? void 0 : PDICheckKeys.Paging]) === null || _crud$PDICheckKeys$Pa === void 0 ? void 0 : _crud$PDICheckKeys$Pa.count) != null ? crud[PDICheckKeys === null || PDICheckKeys === void 0 ? void 0 : PDICheckKeys.Paging].count : (_crud$PDICheckKeys$Pa2 = (_crud$PDICheckKeys$Pa3 = crud[PDICheckKeys === null || PDICheckKeys === void 0 ? void 0 : PDICheckKeys.PagingCount]) === null || _crud$PDICheckKeys$Pa3 === void 0 ? void 0 : _crud$PDICheckKeys$Pa3.FailedCount) !== null && _crud$PDICheckKeys$Pa2 !== void 0 ? _crud$PDICheckKeys$Pa2 : '0',
                                            color: "error",
                                            variant: "filled",
                                            size: "small"
                                        })
                                    }
                                }, {
                                    id: 'pass',
                                    Name: 'Passed',
                                    elements: PDIPassTAb,
                                    tabProps: {
                                        iconPosition: 'end',
                                        icon: /*#__PURE__*/ React.createElement(Chip, {
                                            label: state !== null && state !== void 0 && state.applyFilter && (state === null || state === void 0 ? void 0 : state.Tabs) === "pass" && ((_crud$PDICheckKeys$Pa4 = crud[PDICheckKeys === null || PDICheckKeys === void 0 ? void 0 : PDICheckKeys.Paging]) === null || _crud$PDICheckKeys$Pa4 === void 0 ? void 0 : _crud$PDICheckKeys$Pa4.count) != null ? crud[PDICheckKeys === null || PDICheckKeys === void 0 ? void 0 : PDICheckKeys.Paging].count : (_crud$PDICheckKeys$Pa5 = (_crud$PDICheckKeys$Pa6 = crud[PDICheckKeys === null || PDICheckKeys === void 0 ? void 0 : PDICheckKeys.PagingCount]) === null || _crud$PDICheckKeys$Pa6 === void 0 ? void 0 : _crud$PDICheckKeys$Pa6.PassedCount) !== null && _crud$PDICheckKeys$Pa5 !== void 0 ? _crud$PDICheckKeys$Pa5 : '0'
                                            // label={state?.applyFilter && state?.Tabs === "pass" ? crud?.[PDICheckKeys?.Paging]?.count ?? '0' : crud?.[PDICheckKeys?.PagingCount]?.PassedCount ?? '0'}
                                            ,
                                            color: "success",
                                            variant: "filled",
                                            size: "small",
                                            sx: {
                                                marginLeft: 1
                                            }
                                        })
                                    }
                                }]
                        };
                    }
                }]
        }];
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        formData: formData,
        mode: "edit",
        getFormAPI: PDIStatusPagingCountAPI,
        getKey: PDICheckKeys === null || PDICheckKeys === void 0 ? void 0 : PDICheckKeys.PagingCount,
        getRequest: {
            OrganizationId: userOrganizationID,
            ParentOrganizationId: parentOrganizationId
        },
        onChange: function (e, _ref) {
            var state = _ref.state, field = _ref.field, value = _ref.value;
            console.log('Onchange--', state);
            if (e && (field === null || field === void 0 ? void 0 : field.name) === 'Tabs' || (field === null || field === void 0 ? void 0 : field.name) === 'IdentityId') {
                dispatch(setReducerState({
                    key: getUpdateKey(PDICheckKeys === null || PDICheckKeys === void 0 ? void 0 : PDICheckKeys.Paging),
                    value: true
                }));
            }
        },
        gridProps: {
            spacing: 0
        }
    }));
};
export default NewPDICheckPaging;
